<template>
  <div class="popup-form">
    <div class="content-form-popup">
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img
            class="nav-link-icon filter-primary"
            src="@/images/modal-close.svg"
            alt=""
          />
        </div>
        <div class="blackcolor pop-800">Refixácia</div>
        <button form="refixation-submit" class="w-button saveformBtn">Aktualizovať</button>
      </div>

        <form @submit.prevent="saveRefixation" id="refixation-submit">
          <div class="input-group">
            <label for="najomne" class="field-label">
              Nová úroková sadzba
            </label>
            <input
              v-model.number="form.sadzba_schvalena"
              type="number"
              step="0.01"
              min="0"
              max="99.99"
              inputmode="decimal"
              class="text-input w-input required"
              maxlength="256"
              required
            />
          </div>
          <div class="input-group">
            <label for="najomne" class="field-label">
              Trvanie novej fixácie (roky)
            </label>
            <input
              v-model="form.fix"
              type="number"
              min="1"
              max="40"
              step="1"
              class="text-input w-input required"
              maxlength="256"
              required
            />
          </div>
          <div class="input-group">
            <label for="zaciatok-fixacie" class="field-label">
              Začiatok novej fixácie
            </label>
            <input
              id="zaciatok-fixacie"
              v-model="form.zaciatok_fixacie"
              type="date"
              :min="debt?.zaciatok || null"
              :max="today"
              class="text-input w-input required"
              required
            />
          </div>
          <div class="input-group">
            <label for="nova-splatka" class="field-label">
              Nová splátka
            </label>
            <input
              id="nova-splatka"
              :value="formattedPayment"
              type="text"
              class="text-input w-input input-color-disabled"
              readonly
            />
            <div class="refixation-hint">
              Počíta sa zo zostatku {{ numericBalance | dotTheAmount }} EUR a zo zostávajúcich
              {{ remainingMonths }} mesiacov. Server výpočet pri uložení ešte overí podľa splátkového kalendára.
            </div>
          </div>
        </form>

    </div>
  </div>
</template>

<script>
import {refixMortgageApplication} from "@/services/brokerService";

export default {
  name: "ApplicationRefixationPopUp",
  props: {
    payload: Object
  },
  created() {
    const servicedApplication = this.mortgage.applications.filter((a) => a.stage === "nacerpana")[0];

    this.application = servicedApplication;
    this.debt = servicedApplication?.vytvoreny_debt || null;
    this.form.sadzba_schvalena = Number(
      servicedApplication?.sadzba_schvalena ?? servicedApplication?.sadzba_pozadovana ?? 0
    );
    this.form.fix = Number(this.debt?.fixacia || servicedApplication?.fix || 1);
    this.form.zaciatok_fixacie = this.today;
    this.recalculatePayment();
  },
  data() {
    return {
      mortgage: this.payload,
      application: null,
      debt: null,
      today: new Date().toISOString().slice(0, 10),
      calculatedPayment: 0,
      remainingMonths: 0,
      form: {
        fix: 0,
        sadzba_schvalena: 0,
        zaciatok_fixacie: null,
      }
    }
  },
  computed: {
    numericBalance() {
      const raw = this.debt?.aktualny_zostatok?.value
        ?? this.debt?.aktualny_zostatok
        ?? this.debt?.zostatok?.value
        ?? this.debt?.zostatok
        ?? 0;
      const parsed = Number(raw);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    formattedPayment() {
      return Number.isFinite(this.calculatedPayment)
        ? `${this.calculatedPayment.toFixed(2).replace(".", ",")} EUR`
        : "—";
    },
  },
  watch: {
    "form.sadzba_schvalena": "recalculatePayment",
    "form.zaciatok_fixacie": "recalculatePayment",
  },
  methods: {
    calculateRemainingMonths() {
      if (!this.form.zaciatok_fixacie || !this.debt?.splatnost) {
        return Number(this.debt?.zostavajuca_splatnost_mesiace || 0);
      }
      const start = new Date(`${this.form.zaciatok_fixacie}T00:00:00`);
      const maturity = new Date(`${this.debt.splatnost}T00:00:00`);
      let months = (maturity.getFullYear() - start.getFullYear()) * 12
        + maturity.getMonth() - start.getMonth();
      if (maturity.getDate() > start.getDate()) months += 1;
      return Math.max(0, months);
    },
    recalculatePayment() {
      this.remainingMonths = this.calculateRemainingMonths();
      const principal = this.numericBalance;
      const annualRate = Number(this.form.sadzba_schvalena);
      if (!principal || !this.remainingMonths || !Number.isFinite(annualRate)) {
        this.calculatedPayment = 0;
        return;
      }
      const monthlyRate = annualRate / 100 / 12;
      this.calculatedPayment = monthlyRate === 0
        ? principal / this.remainingMonths
        : principal * monthlyRate / (1 - Math.pow(1 + monthlyRate, -this.remainingMonths));
    },
    async saveRefixation() {
      const debt = this.debt;
      if (!debt || typeof debt !== "object") {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Refixáciu nie je možné uložiť, pretože k žiadosti chýba načerpaný úver.",
          type: "error",
        });
        return;
      }

      try {
        const result = await refixMortgageApplication(this.application.id, {
          sadzba: Number(this.form.sadzba_schvalena),
          fixacia_roky: Number(this.form.fix),
          zaciatok_fixacie: this.form.zaciatok_fixacie,
        });
        this.calculatedPayment = Number(result.application.splatka);
        this.remainingMonths = result.zostavajuca_splatnost_mesiace;

        await this.$store.dispatch("mortgagesState/patcMortgage", {
          mortgageInfo: {id: this.mortgage.id},
          expand: "coapplicant,applicant.client_profile,applications.vytvoreny_debt,applicant.debts",
        });
        this.$store.commit("appState/setSuccessMessage", {
          text: `Refixácia bola uložená. Nová splátka je ${this.formattedPayment}.`,
          type: "success",
        });
        this.closePopup();
      } catch (error) {
        const details = error?.response?.data;
        const message = details && typeof details === "object"
          ? Object.values(details).flat().join(" ")
          : "Refixáciu sa nepodarilo uložiť.";
        this.$store.commit("appState/setSuccessMessage", {text: message, type: "error"});
      }
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
}
</script>

<style scoped>
.refixation-hint {
  margin-top: 8px;
  color: var(--app-text-muted, #6f7f96);
  font-size: 12px;
  line-height: 1.45;
}
</style>
